import { Outlet } from "react-router-dom";
import AppLoader from "../components/loading/AppLoader";

const AppLayout = () => {
  return (
    <AppLoader>
      <Outlet />
    </AppLoader>
  );
};

export default AppLayout;
